export const Lotties = {
  loading: require('../Assets/Lotties/loading-lottie.json')
};
